// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__3z9RO"};